/**
 * Design-set names, for the chat panel's Set pin.
 *
 * Derived from the kit's component metrics rather than hardcoded: every
 * `SM_<Set>_*.glb` names its set, and Core is the plain-filename geometry
 * (it ships no SM_Core_* files).
 */

import { COMPONENT_METRICS } from './wrappers';

export const DESIGN_SETS: readonly string[] = [
    'Core',
    ...[...new Set(Object.keys(COMPONENT_METRICS)
        .map(file => /^SM_([^_]+)_/.exec(file)?.[1])
        .filter((set): set is string => !!set))]
        .sort(),
];
